import React, { memo } from 'react'

import TableCellData from '../DataTable/TableCellData'
import UserProfileAvatar from '../UserProfileAvatar/UserProfileAvatar'

const BadgeColumn = ({ badge, invert, size, sx, tableCellSx }) => {
  return (
    <TableCellData
      textProps={{ fontWeight: 700, fontSize: '1.125rem' }}
      sx={tableCellSx}
    >
      <UserProfileAvatar invert={invert} variant='rounded' size={size} sx={sx}>
        {badge}
      </UserProfileAvatar>
    </TableCellData>
  )
}

export default memo(BadgeColumn)
